import React, { Component } from "react";
import {
  Button,
  Select,
  Form,
  Input,
  Avatar,
  Upload,
  message,
  Modal,
} from "antd";
import PhoneInput, {
  isValidPhoneNumber,
  parsePhoneNumber,
} from "react-phone-number-input";
import localization from "../../Localization/Localization.json";
import "./Profile.scss";
import {
  FaSave,
  FaTimes,
  FaLock,
  FaSignOutAlt,
  FaPen,
  FaCamera,
} from "react-icons/fa";
import { setCurrentUser } from "../../redux/user/user.action";
import { connect } from "react-redux";
import { ChangePasswordReq, EditCustomer } from "../../network/profile.network";
import { userLogout } from "../../network/auth.network";
const { Option } = Select;
const { confirm, info } = Modal;

class Profile extends Component {
  formUserRef = React.createRef();
  formPassRef = React.createRef();

  state = {
    loading: false,
    showAdd: false,
    inputLoading: false,
    numberVal: "",
    showTab: "personal",
    avatar_img: "",
  };

  beforeUpload = (file) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const img = document.createElement("img");
        img.src = reader.result;
        this.setState({ avatar_img: reader.result });
      };
    });
  };

  handelLogout = () => {
    userLogout(
      (res) => {
        localStorage.removeItem("tokenCi");
        localStorage.setItem("isAuthenticatedCi", false);
        localStorage.setItem("role", null);
        this.props.dispatch(setCurrentUser(null));
        this.props.history.push("/");
      },
      (error) => {
        //console.log(error);
      }
    );
  };

  handelChangePassword = (values) => {
    this.setState({ inputLoading: true });
    let params = `?CurrentPassword=${values.CurrentPassword}&NewPassword=${values.NewPassword}&ConfirmNewPassword=${values.ConfirmNewPassword}`;
    ChangePasswordReq(
      params,
      (res) => {
        this.setState({ inputLoading: false });
        message.success("تم تغيير كلمة المرور بنجاح");
        setTimeout(() => {
          this.formPassRef.current.resetFields();
        }, 300);
      },
      (err) => {
        this.setState({ inputLoading: false });
      }
    );
  };

  handelEditMyProfile = (values) => {
    this.setState({ inputLoading: true });
    const { currentUser } = this.props;
    const phoneNumber = parsePhoneNumber(values.PhoneNumber || "");
    let body = {
      Id: currentUser.Id,
      IdentityId: currentUser.IdentityId,
      EmployerName: currentUser.EmployerName,
      NationalIdentityNumber: currentUser.NationalIdentityNumber,
      BirthDate: currentUser.BirthDate,
      Salary: currentUser.Salary,
      HousingAllowance: currentUser.HousingAllowance,
      TransportationAllowance: currentUser.TransportationAllowance,
      IsSupported: currentUser.IsSupported,
      JobTitleId: currentUser.JobTitleId,
      EmployerId: currentUser.EmployerId,
      GenderId: currentUser.GenderId,
      CityId: currentUser.CityId,
      BankId: currentUser.BankId,
      PhoneNumber: phoneNumber.nationalNumber,
      PhoneKey: "+" + phoneNumber.countryCallingCode,
      Email: currentUser.AspNetUsers.Email,
      FullName: values.FullName,
    };
    EditCustomer(
      body,
      (res) => {
        const updateUser = {
          ...this.props.currentUser,
          FullName: res.data.model.AspNetUsers.FullName,
          PhoneKey: res.data.model.AspNetUsers.PhoneKey,
          PhoneNumber: res.data.model.AspNetUsers.PhoneNumber,
        };
        this.props.dispatch(setCurrentUser(res.data.model));
        message.success("تم تعديل الحساب بنجاح");
        this.setState({ inputLoading: false, showAdd: false });
      },
      (error) => {
        //console.log(error)
        this.setState({ inputLoading: false });
      }
    );
    this.setState({ inputLoading: false });
  };

  render() {
    const { showAdd, showTab, avatar_img, inputLoading } = this.state;
    const { currentUser, currentLang } = this.props;

    return (
      <div className="profile-page-wrapper">
        <div className="container">
          <h1 className="profile-page-title">حسابي الشخصي</h1>
          <div className="profile-content-wrapper">
            <div className="profile-content-sidebar">
              <div className="sidebar-card sidebar-card-img">
                <div className="avatar-holder">
                  <Avatar size={100} src={avatar_img} />
                  <Upload
                    beforeUpload={this.beforeUpload}
                    accept=".png, .jpg, .jpeg"
                  >
                    <FaCamera />
                  </Upload>
                </div>
              </div>
              <div
                className="sidebar-card sidebar-card-pass blue-color"
                onClick={() => this.setState({ showTab: "password" })}
              >
                <FaLock />
                تغيير كلمه المرور
              </div>
              <div
                className="sidebar-card sidebar-card-out red-color"
                onClick={this.handelLogout}
              >
                <FaSignOutAlt />
                تسجيل الخروج
              </div>
            </div>
            <div className="profile-content-info">
              {showTab === "personal" && (
                <div className="personal-data-holder">
                  <header className="client-header">
                    <h2 className="info-title">بيانات العميل</h2>
                    {!showAdd && (
                      <div className="header-btn-holder">
                        <Button
                          type="primary"
                          size="large"
                          ghost
                          className="blue-btn"
                          onClick={() => {
                            this.setState({
                              showAdd: true,
                              numberVal:
                                currentUser?.AspNetUsers?.PhoneKey +
                                currentUser?.AspNetUsers?.PhoneNumber,
                            });
                            setTimeout(() => {
                              this.formUserRef.current.setFieldsValue({
                                FullName: currentUser?.AspNetUsers?.FullName,
                                PhoneNumber:
                                  currentUser?.AspNetUsers?.PhoneKey +
                                  currentUser?.AspNetUsers?.PhoneNumber,
                              });
                            }, 300);
                          }}
                          icon={<FaPen />}
                        >
                          تعديل
                        </Button>
                      </div>
                    )}
                  </header>
                  {!showAdd ? (
                    <div className="info-grid">
                      <div className="info-grid-cell">
                        <p className="info-cell-p">الاسم </p>
                        <h6 className="info-cell-val">
                          {currentUser.AspNetUsers.FullName}
                        </h6>
                      </div>

                      <div className="info-grid-cell">
                        <p className="info-cell-p">البريد الالكتروني</p>
                        <h6 className="info-cell-val">
                          {currentUser.AspNetUsers.Email}
                        </h6>
                      </div>

                      <div className="info-grid-cell">
                        <p className="info-cell-p">رقم الجوال</p>
                        <h6 className="info-cell-val phone-style">
                          {currentUser.AspNetUsers.PhoneKey +
                            currentUser.AspNetUsers.PhoneNumber}
                        </h6>
                      </div>
                    </div>
                  ) : (
                    <Form
                      className="form-add-content"
                      layout="vertical"
                      name="nest-messages"
                      onFinish={this.handelEditMyProfile}
                      ref={this.formUserRef}
                    >
                      <div className="form-content">
                        <Form.Item
                          label="الاسم"
                          name="FullName"
                          className="input-holder"
                          rules={[
                            {
                              required: true,
                              message: `${localization.pleaseInput[currentLang]} 
                            ${localization.EmployeeName[currentLang]}`,
                            },
                          ]}
                        >
                          <Input placeholder="" />
                        </Form.Item>

                        <Form.Item
                          label={localization.Mobilenumber[currentLang]}
                          name="PhoneNumber"
                          className="input-holder"
                          rules={[
                            // { required: true, message: `${localization.pleaseInput[currentLang]}
                            // ${localization.Mobilenumber[currentLang]}` },
                            {
                              validator(_, value) {
                                let phoneValid = isValidPhoneNumber(
                                  value || ""
                                );
                                if (!value)
                                  return Promise.reject(
                                    "من فضلك ادخل رقم الجوال"
                                  );
                                else if (!phoneValid)
                                  return Promise.reject("رقم الجوال غير صحيح");
                                else return Promise.resolve();
                              },
                            },
                          ]}
                        >
                          <PhoneInput
                            international
                            countryCallingCodeEditable={false}
                            defaultCountry="SA"
                            value={this.state.numberVal}
                            onChange={(val) =>
                              this.setState({ numberVal: val })
                            }
                          />
                        </Form.Item>
                      </div>
                      <div className="form-btns-action">
                        <Button
                          className="xlg ml-20"
                          size="large"
                          type="primary"
                          ghost
                          danger
                          onClick={() => this.setState({ showAdd: false })}
                        >
                          <FaTimes />
                          الغاء
                        </Button>
                        <Button
                          htmlType="submit"
                          size="large"
                          className="blue-btn xlg"
                          type="primary"
                          loading={inputLoading}
                        >
                          <FaSave />
                          حفظ
                        </Button>
                      </div>
                    </Form>
                  )}
                </div>
              )}

              {showTab === "password" && (
                <div className="change-pass-form">
                  <h2 className="info-title">تغيير كلمه المرور</h2>
                  <Form
                    className="form-add-content"
                    layout="vertical"
                    name="nest-messages"
                    ref={this.formPassRef}
                    onFinish={this.handelChangePassword}
                  >
                    <div className="form-content">
                      <Form.Item
                        name="CurrentPassword"
                        label={localization.oldpassword["ar"]}
                        className="input-holder grid-row-full"
                        rules={[
                          {
                            required: true,
                            message: `${localization.pleaseInput["ar"]} ${localization.oldpassword["ar"]}`,
                          },
                        ]}
                        hasFeedback
                      >
                        <Input.Password
                          placeholder={localization.oldpassword["ar"]}
                          className="input-control"
                        />
                      </Form.Item>

                      <Form.Item
                        name="NewPassword"
                        label={localization.newpassword["ar"]}
                        className="input-holder grid-row-full"
                        rules={[
                          {
                            required: true,
                            message: "من فضلك ادخل كلمة المرور الجديد",
                          },
                          {
                            min: 8,
                            message: "يجب ان تكون كلمة المرور أكبر من 8 أحرف",
                          },
                          {
                            max: 20,
                            message: "يجب ان تكون كلمة المرور اقل من 20 حرف",
                          },
                          // {
                          //     //Password expresion that requires one lower case letter, one upper case letter, one digit, 6-13 length, and no spaces.This is merely an extension of a previously posted expression by Steven Smith(ssmith@aspalliance.com) . The no spaces is new.
                          //     pattern: new RegExp(
                          //         "(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,20})"
                          //     ),
                          //     message: "يجب أن تحتوي كلمة المرور على حروف كبيرة وأرقام ورموز",

                          // },
                        ]}
                        hasFeedback
                      >
                        <Input.Password
                          placeholder={localization.newpassword["ar"]}
                          className="input-control"
                        />
                      </Form.Item>

                      <Form.Item
                        name="ConfirmNewPassword"
                        label={localization.confirmpassword["ar"]}
                        dependencies={["NewPassword"]}
                        className="input-holder grid-row-full"
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: `${localization.pleaseInput["ar"]} ${localization.confirmpassword["ar"]}`,
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              if (
                                !value ||
                                getFieldValue("NewPassword") === value
                              ) {
                                return Promise.resolve();
                              }
                              return Promise.reject(
                                new Error(
                                  `${localization.Thetwopasswords["ar"]}`
                                )
                              );
                            },
                          }),
                        ]}
                      >
                        <Input.Password
                          placeholder={localization.confirmpassword["ar"]}
                          className="input-control"
                        />
                      </Form.Item>
                    </div>
                    <div className="form-btns-action">
                      <Button
                        className="xlg ml-20"
                        size="large"
                        type="primary"
                        ghost
                        danger
                        onClick={() =>
                          this.setState({ showTab: "personal", showAdd: false })
                        }
                      >
                        <FaTimes />
                        الغاء
                      </Button>
                      <Button
                        htmlType="submit"
                        size="large"
                        className="blue-btn xlg"
                        type="primary"
                        loading={inputLoading}
                      >
                        <FaSave />
                        حفظ
                      </Button>
                    </div>
                  </Form>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentLang: state.user.currentLang,
});
export default connect(mapStateToProps)(Profile);
